var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-12 col-md-4 mb-3 card-wrap" }, [
    _c(
      "div",
      {
        staticClass: "card h-100 card-clinical_trial bg-white p-4",
        attrs: { "data-locations": _vm.location_ids },
      },
      [
        _vm.background_image
          ? _c("div", { staticClass: "card-background-image" }, [
              _c("img", { attrs: { src: "background_image", alt: "" } }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "card-body px-0 pt-0 d-flex flex-column" }, [
          _c("div", { staticClass: "card-title mb-2" }, [
            _c("h5", [_vm._v(_vm._s(_vm.title))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-description" }, [
            _c("p", [_vm._v(_vm._s(_vm.excerpt))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clinical-details" }, [
            _vm.cancer_types
              ? _c("div", { staticClass: "cancer-types" }, [
                  _c("h6", [_vm._v("Cancer Types:")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "d-inline",
                    domProps: { innerHTML: _vm._s(_vm.cancer_types) },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.therapy_lines
              ? _c("div", { staticClass: "therapy-lines" }, [
                  _c("h6", [_vm._v("Lines of Therapy:")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-inline" }, [
                    _vm._v(_vm._s(_vm.therapy_lines)),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.locations
              ? _c("div", { staticClass: "locations" }, [
                  _c("h6", [_vm._v("Locations:")]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-unstyled d-inline" },
                    _vm._l(_vm.locations, function (location, index) {
                      return _c(
                        "li",
                        { key: location.url, staticClass: "d-inline" },
                        [
                          _c(
                            "a",
                            { attrs: { href: location.url, target: "_blank" } },
                            [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(location.title) },
                              }),
                            ]
                          ),
                          index !== _vm.locations.length - 1
                            ? [_vm._v(", ")]
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-footer p-0" }, [
          _c(
            "a",
            {
              staticClass: "btn btn-primary",
              attrs: {
                href: _vm.trial_link,
                target: "_blank",
                "aria-label": "View Details on clinicaltrials.gov",
              },
            },
            [
              _vm._v(
                "\n                View Details on ClinicalTrials.gov\n            "
              ),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }